import { createContext, ReactNode, useContext, useEffect, useState } from "react";

type MobileHeaderState = {
  title: string | null;
  actions: ReactNode | null;
};

type MobileHeaderContextType = MobileHeaderState & {
  setHeader: (title: string, actions: ReactNode) => void;
  clearHeader: () => void;
};

const MobileHeaderContext = createContext<MobileHeaderContextType>({
  title: null,
  actions: null,
  setHeader: () => {},
  clearHeader: () => {},
});

export function useMobileHeaderState() {
  const [header, setHeaderState] = useState<MobileHeaderState>({ title: null, actions: null });

  const setHeader = (title: string, actions: ReactNode) => setHeaderState({ title, actions });
  const clearHeader = () => setHeaderState({ title: null, actions: null });

  return { ...header, setHeader, clearHeader };
}

export function useMobileHeaderActions(title: string, actions: ReactNode) {
  const { setHeader, clearHeader } = useContext(MobileHeaderContext);

  useEffect(() => {
    if (title) {
      setHeader(title, actions);
      return () => clearHeader();
    }
  }, [title, actions]);
}

export default MobileHeaderContext;
